import { render, staticRenderFns } from "./product-categories.vue?vue&type=template&id=f8fe7d5e"
import script from "./product-categories.vue?vue&type=script&lang=js"
export * from "./product-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports